import React from "react";
import "../assets/css/home.css";

function Footer() {
  return (
    <React.Fragment>
      <footer className="text-center text-lg-start siterbang-bg mt-5">
        <div className="container text-center mt-5">
          <div className="row text-white ">
            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4 mt-5">
              <h6 className>Companny Name</h6>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Officiis a amet pariatur laboriosam aliquid optio ad saepe
                officia reprehenderit fugiat ipsam dignissimos molestias,
                impedit, necessitatibus tenetur excepturi magni id iusto?
              </p>
            </div>
            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4 mt-5">
              <h6>Products kami</h6>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
            </div>
            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4 mt-5">
              <h6>Products kami</h6>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
            </div>
            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4 mt-5">
              <h6>Products kami</h6>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
              <p>react bos</p>
            </div>
          </div>
        </div>

        <section className=" text-center p-4 border-top mb-0 ">
          <div className="me-5 d-lg block">
            <h6 className="text-white ">
              &copy; siterbang - by designed FExBE-2
            </h6>
          </div>
        </section>
      </footer>
    </React.Fragment>
  );
}

export default Footer;
